<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE ref="auditUpdate"  @submit="auditClick" :updateData="auditData"></UPDATE>
    <UPDATE  ref="blacklistData" @submit="blacklistClick" :updateData="blacklistData" @uploadFile="uploadFile"></UPDATE>
    <UPDATE  ref="userAssignData" @submit="userAssignClick" :updateData="userAssignData" @uploadFile="uploadFile"></UPDATE>
    <!--编辑-->
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
      <template v-slot:taskContent="update">
        <!--任务列表-->
        <TASK :update="update"></TASK>
      </template>
    </UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import TASK from '@/views/crs36/task/task.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import URL from "@/views/crs36/util/url"
    let androidChannel={};
    let iosChannel={};
    let bankName={};
    let rewardDateType={"1":window.$t("crs36.task.rewardDateType1")}
    let userLevel={"MIN":window.$t("crs36.task.min"),"STD":window.$t("crs36.task.std"),"PLA":window.$t("crs36.task.pla"),"ZER":window.$t("crs36.task.zer")};
    let jumpType = {1:window.$t("crs36.task.jumpType1"),2:window.$t("crs36.task.jumpType2"),3:window.$t("crs36.task.jumpType3")};
    let jumpAppOptins={0:window.$t("crs36.task.jumpAppOptins0"),1:window.$t("crs36.task.jumpAppOptins1"),2:window.$t("crs36.task.jumpAppOptins2"),3:window.$t("crs36.task.jumpAppOptins3"),4:window.$t("crs36.task.jumpAppOptins4"),6:window.$t("crs36.task.jumpAppOptins6"),8:window.$t("crs36.task.jumpAppOptins8"),9:window.$t("crs36.task.jumpAppOptins9"),10:window.$t("crs36.task.jumpAppOptins10")};
    let auditStatus=  {"1":window.$t("crs36.task.pass"),"2":window.$t("crs36.task.noPass")}
    let auditStatus2= {"0":window.$t("crs36.task.auditStatus0"),"1":window.$t("crs36.task.auditStatus1"),"2":window.$t("crs36.task.auditStatus2"),"3":window.$t("crs36.task.auditStatus3")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE,
            TASK
        },
        created(){
            this.getTask();
        },
        mounted(){

        },
        methods: {
            /*上传指定用户*/
            userAssignClick(row){
                row.userList = this.user;
                this.dataChanage(URL.task.addUserAssign,row,res => {
                    if (res.code == 0){
                        this.$refs.userAssignData.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            /*导入黑名单用户*/
            blacklistClick(row){
                row.userList = this.user;
                this.dataChanage(URL.task.importBlacklist,row,res => {
                    if (res.code == 0){
                        this.$refs.blacklistData.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            /*审核*/
            auditClick(row){
                this.$axios.get(`${URL.task.status}/${row.id}`+'/'+row.auditStatus).then(res => {
                    if (res.code == 0){
                        this.$refs.auditUpdate.close();
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
                row.time = [row.startDate,row.endDate];
                row.userLevel = row.userLevel.split(",");
                row.androidChannel = row.androidChannel.split(",");
                row.iosChannel = row.iosChannel.split(",");
                for (let i in row.list) {
                    if (row.list[i].conditionsType == 1){
                        row.list[i].conditionsValue = row.list[i].conditionsValue.split(",");
                        row.list[i].conditionsProductType = row.list[i].conditionsProductType.split(",");
                    }
                }
              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${URL.task.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }else if(clickName == "practice"){
                this.$router.push({path:"/crs36/task/taskList", query: { activityId:row.id ,label:"CRS36"} })
            }else if(clickName == "copy"){
                row.time = [row.startDate,row.endDate];
                row.userLevel = row.userLevel.split(",");
                row.androidChannel = row.androidChannel.split(",");
                row.iosChannel = row.iosChannel.split(",");
                for (let i in row.list) {
                    if (row.list[i].conditionsType == 1){
                        row.list[i].conditionsValue = row.list[i].conditionsValue.split(",");
                        row.list[i].conditionsProductType = row.list[i].conditionsProductType.split(",");
                    }
                }
                row.id=0.1;
                this.$refs.childUpdate.open(row);
            }else if (clickName == "updateStatus"){
                if(row.auditStatus == 0) {
                    this.$refs.auditUpdate.open(row);
                }else {
                    let status = row.auditStatus == 1 ? 2:1;
                    let conf = row.auditStatus == 1 ? window.$t("crs36.task.noPass"):window.$t("crs36.task.pass");
                    this.$confirm(window.$t("common.ok")+conf, window.$t("common.tip"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: window.$t("common.ok"),
                        cancelButtonText: window.$t("common.cancle")
                    }).then(() => {
                        this.$axios.get(`${URL.task.status}/${row.id}`+'/'+status).then(res => {
                            if (res.code == 0){
                                this.$refs.childTable.defaultGetData(this.queryData);
                                this.$message.success("suc");
                            }else{
                                this.$message.error(res.message);
                            }
                        });
                    })
                }
            }else if(clickName == "blacklistImport"){
                row.taskActivityId = row.id;
                this.$refs.blacklistData.open(row);
            }else if(clickName == "userAssignImport"){
                row.taskActivityId = row.id;
                this.$refs.userAssignData.open(row);
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t("common.search") == clickName || "查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t("common.add")==clickName){
                    data.time = [data.startTime,data.endTime];
                  this.$refs.childUpdate.open();
                }
            },
            uploadFile(col,res){
                console.log(col,res);
                this.user = res.join(",");
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                model.startDate = model.time[0];
                model.endDate = model.time[1];
                model.userLevel = model.userLevel.join(",");
                model.androidChannel = model.androidChannel.join(",");
                model.iosChannel = model.iosChannel.join(",");
                if(model.id == 0.1){
                    model.id = null;

                }
                for (let i in model.list) {
                    if (model.list[i].conditionsType == 1){
                        model.list[i].conditionsValue = model.list[i].conditionsValue.join(",");
                        model.list[i].conditionsProductType = model.list[i].conditionsProductType.join(",");
                    }
                }
                //根据是否包含id更新还是添加
                this.dataChanage(URL.task.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })

            },
            getTask(){
                this.$axios.get(URL.task.queryType).then(res => {
                    if (res.code == 0){
                        let data=JSON.parse(JSON.stringify(res.result));
                        for (const i in data){
                            data[i].value=data[i].typeName
                            data[i].key=data[i].id
                        }
                        for (const i in this.updateData.cols){
                            if (this.updateData.cols[i].field=="taskTypeId"){
                                this.updateData.cols[i].optionList=data
                            }
                        }

                    }
                });

                this.axios.post(URL.active.channel.queryAll).then(res => {
                    if (res.code == 0){
                        const result = res.result;
                        for (let i in result) {
                            if (result[i].os == 'Android'){
                                androidChannel[result[i].pkg] = result[i].name;
                            }else if(result[i].os == 'IOS'){
                                iosChannel[result[i].pkg] = result[i].name;
                            }
                        }
                        for (const i in this.updateData.cols){
                            if (this.updateData.cols[i].field=="androidChannel"){
                                this.updateData.cols[i].optionList=androidChannel;
                            }else if(this.updateData.cols[i].field=="iosChannel"){
                                this.updateData.cols[i].optionList=iosChannel;
                            }
                        }
                    }
                });
            }

        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: window.$t("crs36.task.id"), field: 'id',hidden:true},
                        { title: window.$t("crs36.task.id"), field: 'lang',hidden:true,data:"EV"},
                        { title: window.$t("crs36.task.activityName"), field: 'activityName',required:true},
                        { title: window.$t("crs36.task.activityTitleEn"), field: 'activityTitleEn',required:true},
                        { title: window.$t("crs36.task.activityTitleVn"), field: 'activityTitleVn',required:true},
                        {title:  window.$t("crs36.task.taskTime"), field: 'time', type: 9, format: 'yyyy-MM-dd HH:mm:ss',data:[],required:true},
                        { title: window.$t("crs36.task.activityDescEn"), field: 'activityDescEn',required:true},
                        { title: window.$t("crs36.task.activityDescVn"), field: 'activityDescVn',required:true},
                        { title: window.$t("crs36.task.bankName"), field: 'taskTypeId',type:2,optionList:bankName,required:true},
                        { title: window.$t("crs36.task.androidChannel"), field: 'androidChannel',type:4,optionList:androidChannel,data:[]},
                        { title: window.$t("crs36.task.iosChannel"), field: 'iosChannel',type:4,optionList:iosChannel,data:[]},
                        { title: window.$t("crs36.task.userLevel"), field: 'userLevel',type:4,optionList:userLevel,data:[]},
                        { title: window.$t("crs36.task.rewardDateType"), field: 'rewardDateType',type:2,optionList:rewardDateType,isNumber:true,required:true},
                        { title: window.$t("crs36.task.rewardAmount"), field: 'rewardAmount',type:7,required:true,data:0,min:0,precision:2},
                        { title: window.$t("crs36.task.effectiveEndDay"), field: 'effectiveEndDay',type:7,required:true,data:0,min:0,precision:0},
                        { title: window.$t("crs36.task.jumpType"), field: 'jumpType',type:3,optionList:jumpType,isNumber:true,data:1,required:true},
                        { title: window.$t("crs36.task.jumpWeb"), field: 'jumpWeb',required:(model,col)=>{
                                return model.jumpType == 2;
                            },hidden:(model,col)=>{
                                return model.jumpType !=2;
                            }
                        },
                        { title: window.$t("crs36.task.jumpApp"), field: 'jumpApp',type:2,optionList:jumpAppOptins,required:(model,col)=>{
                                return model.jumpType == 3;
                            },hidden:(model,col)=>{
                                return model.jumpType !=3;
                            }
                        },
                        { title: window.$t('crs.active.taskContent'), field: 'list',type:10,slot:'taskContent',data:[{rewardType:1}]}

                    ]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t("crs36.task.id"), field: 'id'},
                        { title: window.$t("crs36.task.id"), field: 'lang',data:"EV",hidden:true},
                        { title: window.$t("crs36.task.activityName"), field: 'activityName'},
                        { title: window.$t("crs36.task.auditStatus"),type:2,optionList:auditStatus,isNumber:true},
                        { title: window.$t("crs36.task.startDate"), field: 'startDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        { title: window.$t("crs36.task.endDate"), field: 'endDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
                        {click:window.$t("common.search")},
                        {click:window.$t("common.add")},
                    ]
                },
                blacklistData:{
                    cols:[
                        {title:'id',field:'taskActivityId',hidden:true},
                        {title:'userList',field:'userList',hidden:true},
                        { title: window.$t("common.import"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},
                    ]
                },
                userAssignData:{
                    cols:[
                        {title:'id',field:'taskActivityId',hidden:true},
                        {title:'userList',field:'userList',hidden:true},
                        { title: window.$t("common.import"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},
                    ]
                },

                /*审核*/
                auditData:{
                    hasLable: true,
                    cols:[
                        { title: '主键', field: 'id',hidden:true},
                        { title: window.$t("crs36.task.audit"), field: 'auditStatus',type:3,optionList:auditStatus,isNumber:true,data:1},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.task.query,
                    selection: false,
                    sequence: false,
                  method:"get",
                    cols: [
                        { title: window.$t("crs36.task.id"), field: 'id'},
                        { title: window.$t("crs36.task.activityName"), field: 'activityName'},
                        { title: window.$t("crs36.task.typeName"), field: 'typeName'},
                        { title: window.$t("crs36.task.startDate"), field: 'startDate'},
                        { title: window.$t("crs36.task.endDate"), field: 'endDate'},
                        { title: window.$t("crs36.task.assignCount"), field: 'assignCount'},
                        { title: window.$t("crs36.task.androidChannel"), field: 'androidChannel'},
                        { title: window.$t("crs36.task.iosChannel"), field: 'iosChannel'},
                        { title: window.$t("crs36.task.auditStatus"), field: 'auditStatus',render:(data)=>{
                                return auditStatus2[data];
                            }},
                        { title: window.$t("crs36.task.realName"), field: 'realName'},
                        { title: window.$t("crs36.task.createDate"), field: 'createDate'},
                        { title: window.$t("crs36.task.updateDate"), field: 'updateDate'},
                        {title: window.$t("common.handle"),width:'330px',btnClick:[
                          {
                            name:window.$t("common.edit"),click:"update",type:"text"
                          },
                                {
                                    name:window.$t("crs36.task.detail"),click:"practice",type:"text"
                                },
                          {
                            name:window.$t("crs36.task.copy"),click:"copy",type:"text"
                          },
                                {
                                    name:(data,full)=>{
                                        if(full.auditStatus == 0){
                                            return window.$t("crs36.task.audit")
                                        }else if(full.auditStatus == 1){
                                            return window.$t("crs36.task.noPass")
                                        }else{
                                            return window.$t("crs36.task.pass")
                                        }
                                    },click:"updateStatus",type:"text",confirm:false
                                },
                                {
                                    name:window.$t("crs36.task.blacklistImport"),click:"blacklistImport",type:"text"
                                },
                                {
                                    name:window.$t("crs36.task.userAssign"),click:"userAssignImport",type:"text"
                                },
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
